export { default } from '@material-ui/unstyled/Unstable_TrapFocus';